// import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './AboutMain.module.css';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';

const AboutMain = () => {
  const { t } = useTranslation();

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>{t('lang.aboutTitle')}</h1>

        <p className={styles.text}>{t('lang.aboutText')}</p>
      </div>

      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          exit={{ opacity: 0 }}
          className={styles.imgContainer}
        >
          <img
            src='https://i.ibb.co/DCqhvdH/about.jpg'
            // src="https://i.ibb.co/ysHRCRK/facebook-img2.jpg"
            alt=''
            className={styles.img}
          />

          <img
            src='https://i.ibb.co/DCqhvdH/about.jpg'
            // src="https://i.ibb.co/ysHRCRK/facebook-img2.jpg"
            alt=''
            className={styles.imgBig}
          />
        </motion.div>
      </AnimatePresence>

      <div className={styles.subtitleContainer}>
        <h2 className={styles.subtitle}>{t('lang.aboutSubTitle')}</h2>

        <p className={styles.subtext}>{t('lang.aboutSubText')}</p>
      </div>

      <div className={styles.linkBox}>
        {/* <div className={styles.linkButton}> */}
        <Link to='/contact'>
          <span className={styles.linkText}>{t('lang.contact')}</span>
        </Link>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AboutMain;
